// eslint-disable-next-line func-names
!(function (window) {
  var doc = window.document,
    docEl = doc.documentElement,
    oldMetaList = docEl.querySelectorAll('meta[name="viewport"]'),
    meta = doc.createElement('meta');

  meta.name = 'viewport';
  meta.content = 'width=980, initial-scale=1.0, maximum-scale=1.0, user-scalable=0;';

  if (oldMetaList) {
    for (let i = 0; i < oldMetaList.length; i++) {
      doc.getElementsByTagName('head')[0].removeChild(oldMetaList[i]);
    }
  }
  doc.getElementsByTagName('head')[0].appendChild(meta);

  var recalc = (function refreshRem() {
    var clientWidth = docEl.clientWidth;
    doc.body.className = '';

    if (clientWidth <= 980) {
      docEl.style.height = 100 + '%';
      docEl.style.overflowX = 'auto';
      doc.body.className += ' hzero-mobile';
    } else {
      docEl.style.width = '100%';
      docEl.style.overflow = 'hidden';
    }

    return refreshRem;
  })();

  if (!doc.addEventListener) return;
  doc.addEventListener('DOMContentLoaded', recalc, false);
  window.addEventListener('resize', recalc, false);
})(window);
